import React, { useMemo } from "react";
import dagre from "dagre";
import {
  ReactFlow,
  Background,
  Controls,
  MiniMap,
} from "@xyflow/react";

import "@xyflow/react/dist/style.css";

const nodeWidth = 220;
const nodeHeight = 70;

const dagreGraph = new dagre.graphlib.Graph();
dagreGraph.setDefaultEdgeLabel(() => ({}));

const rawNodes = [
  {
    id: "client",
    label: "ABC Client",
    color: "#4f46e5",
  },

  {
    id: "works",
    label: "Works",
    color: "#7c3aed",
  },

  {
    id: "services",
    label: "Services",
    color: "#16a34a",
  },

  {
    id: "tasks",
    label: "Tasks",
    color: "#f59e0b",
  },

  {
    id: "categories",
    label: "Categories",
    color: "#ec4899",
  },

  {
    id: "uiux",
    label: "UI/UX Design",
    color: "#22c55e",
  },

  {
    id: "webdev",
    label: "Web Development",
    color: "#22c55e",
  },

  {
    id: "seo",
    label: "SEO Optimization",
    color: "#fb923c",
  },

  {
    id: "documents",
    label: "Documents",
    color: "#3b82f6",
  },

  {
    id: "images",
    label: "Images",
    color: "#60a5fa",
  },
];

const rawEdges = [
  {
    id: "e1",
    source: "client",
    target: "works",
  },

  {
    id: "e2",
    source: "works",
    target: "services",
  },

  {
    id: "e3",
    source: "works",
    target: "tasks",
  },

  {
    id: "e4",
    source: "works",
    target: "categories",
  },

  {
    id: "e5",
    source: "services",
    target: "uiux",
  },

  {
    id: "e6",
    source: "services",
    target: "webdev",
  },

  {
    id: "e7",
    source: "tasks",
    target: "seo",
  },

  {
    id: "e8",
    source: "categories",
    target: "documents",
  },

  {
    id: "e9",
    source: "categories",
    target: "images",
  },
];

function layoutElements(nodes, edges) {
  dagreGraph.setGraph({
    rankdir: "LR",
    nodesep: 60,
    ranksep: 120,
  });

  nodes.forEach((node) => {
    dagreGraph.setNode(node.id, {
      width: nodeWidth,
      height: nodeHeight,
    });
  });

  edges.forEach((edge) => {
    dagreGraph.setEdge(edge.source, edge.target);
  });

  dagre.layout(dagreGraph);

  const layoutedNodes = nodes.map((node) => {
    const position = dagreGraph.node(node.id);

    return {
      ...node,
      position: {
        x: position.x,
        y: position.y,
      },
    };
  });

  return {
    nodes: layoutedNodes,
    edges,
  };
}

export default function MineMap() {
  const { nodes, edges } = useMemo(() => {
    const flowNodes = rawNodes.map((item) => ({
      id: item.id,

      data: {
        label: (
          <div
            style={{
              fontSize: 16,
              fontWeight: 600,
            }}
          >
            {item.label}
          </div>
        ),
      },

      style: {
        background: "#fff",
        border: `2px solid ${item.color}`,
        borderRadius: 18,
        padding: 10,
        width: nodeWidth,
        boxShadow: "0 4px 15px rgba(0,0,0,0.08)",
      },

      position: {
        x: 0,
        y: 0,
      },
    }));

    const flowEdges = rawEdges.map((edge) => ({
      ...edge,
      animated: true,
      style: {
        strokeWidth: 3,
      },
      type: "smoothstep",
    }));

    return layoutElements(flowNodes, flowEdges);
  }, []);

  return (
    <div
      style={{
        width: "100vw",
        height: "100vh",
      }}
    >
      <ReactFlow
        nodes={nodes}
        edges={edges}
        fitView
      >
        <MiniMap />
        <Controls />
        <Background gap={20} />
      </ReactFlow>
    </div>
  );
}